import { JSON } from '../utils/types'

export abstract class PaymentMethod {
  readonly amount: string
  readonly currency: string
  readonly orderAmount: string
  readonly orderCurrency: string
  readonly convertedAmount: string
  readonly rate: string
  readonly fees: { name: string, value: string }[] = []
  readonly expirationDate?: string

  constructor(data: JSON) {
    this.amount = data.amount
    this.currency = data.currency
    this.orderAmount = data.order_amount
    this.orderCurrency = data.order_currency
    this.convertedAmount = data.converted_amount
    this.rate = data.rate
    this.expirationDate = data.expiration_date

    const customerFees = data.customer_fees as Record<string, string>

    if (customerFees) {
      for (const [name, value] of Object.entries(customerFees)) {
        this.fees.push({ name, value })
      }
    }
  }
}
